
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-development",
      function () {
        return require("private-next-pages/business-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-development"])
      });
    }
  